import type { RecordKind } from "../types";

interface RecordVisual {
  hex: string;
  cssColor: string;
  dotClass: string;
  iconClass: string;
  chipClass: string;
  activeClass: string;
  buttonClass: string;
}

export const recordVisuals: Record<RecordKind, RecordVisual> = {
  weight: {
    hex: "#2563EB",
    cssColor: "var(--ui-weight)",
    dotClass: "bg-weight",
    iconClass: "bg-weight-soft text-weight-strong",
    chipClass: "bg-weight-soft text-weight-strong",
    activeClass: "border-weight bg-weight text-white",
    buttonClass: "bg-weight text-white hover:brightness-110",
  },
  vitals: {
    hex: "#D84B45",
    cssColor: "var(--ui-vitals)",
    dotClass: "bg-vitals",
    iconClass: "bg-vitals-soft text-vitals-strong",
    chipClass: "bg-vitals-soft text-vitals-strong",
    activeClass: "border-vitals bg-vitals text-white",
    buttonClass: "bg-vitals text-white hover:brightness-110",
  },
  exercise: {
    hex: "#3F8F55",
    cssColor: "var(--ui-exercise)",
    dotClass: "bg-exercise",
    iconClass: "bg-exercise-soft text-exercise-strong",
    chipClass: "bg-exercise-soft text-exercise-strong",
    activeClass: "border-exercise bg-exercise text-white",
    buttonClass: "bg-exercise text-white hover:brightness-110",
  },
  appointment: {
    hex: "#C99518",
    cssColor: "var(--ui-appointment)",
    dotClass: "bg-appointment",
    iconClass: "bg-appointment-soft text-appointment-strong",
    chipClass: "bg-appointment-soft text-appointment-strong",
    activeClass: "border-appointment bg-appointment text-appointment-ink",
    buttonClass: "bg-appointment text-appointment-ink hover:brightness-110",
  },
};

export const pressureSeriesColors = {
  systolic: recordVisuals.vitals.hex,
  diastolic: "#6D5BD0",
  pulse: "#168AAD",
} as const;

export const pressureSeriesCssColors = {
  systolic: "var(--ui-vitals)",
  diastolic: "var(--ui-vitals-secondary)",
  pulse: "var(--ui-heart-rate)",
} as const;
